import { Handle, Position } from '@xyflow/react';

const modeColors = {
  PDV:        'bg-emerald-900/40 text-emerald-300 border border-emerald-700/50',
  STANDALONE: 'bg-amber-900/40 text-amber-300 border border-amber-700/50',
};

const statusColors = {
  active:      'bg-emerald-900/40 text-emerald-300',
  disabled:    'bg-red-900/40 text-red-300',
  maintenance: 'bg-yellow-900/40 text-yellow-300',
};

export default function TerminalNode({ data }) {
  const { terminal } = data;

  if (!terminal) {
    return (
      <div
        className="px-3 py-2 rounded-lg border border-dashed border-slate-600 bg-bg text-center min-w-[140px] cursor-pointer hover:border-slate-400 transition-all"
      >
        <Handle type="target" position={Position.Top} className="!bg-slate-600" />
        <span className="text-xs text-slate-500">Sin terminal ⚠</span>
      </div>
    );
  }

  const hasDiscrepancy = terminal.discrepancies?.length > 0;
  const mode = terminal.operating_mode;
  const status = terminal.mp_status || terminal.status;

  return (
    <div
      className={`px-3 py-2 rounded-lg border shadow min-w-[160px] transition-all ${
        !terminal.in_mp
          ? 'bg-red-900/10 border-red-600/40'
          : hasDiscrepancy
            ? 'bg-amber-900/10 border-amber-600/40 hover:border-amber-400'
            : 'bg-bg border-border hover:border-border-strong'
      }`}
    >
      <Handle type="target" position={Position.Top} className="!bg-slate-600" />
      <div className="flex items-center gap-1.5 mb-1">
        <span className="text-sm">💳</span>
        <span
          className="text-xs font-mono text-slate-300 truncate max-w-[110px]"
          title={terminal.mp_terminal_id}
        >
          {terminal.mp_terminal_id?.slice(-12)}
        </span>
        {hasDiscrepancy && <span className="text-amber-400 text-sm ml-auto" title="Discrepancia">⚠</span>}
      </div>

      {terminal.model && <div className="text-xs text-slate-500 mb-1">{terminal.model}</div>}

      <div className="flex flex-wrap gap-1">
        {mode && (
          <span className={`text-xs px-1.5 py-0.5 rounded border font-medium ${modeColors[mode] || 'bg-slate-700 text-slate-300'}`}>
            {mode}
          </span>
        )}
        {status && (
          <span className={`text-xs px-1.5 py-0.5 rounded ${statusColors[status] || 'bg-slate-700 text-slate-300'}`}>
            {status}
          </span>
        )}
      </div>

      {terminal.discrepancies?.includes('mp_terminal_not_found') && (
        <p className="mt-1 text-xs text-slate-500 text-center italic">No en listado MP · click</p>
      )}
      {terminal.discrepancies?.includes('not_pdv_mode') && (
        <p className="mt-1 text-xs text-amber-400 text-center italic">Modo: {mode} · click</p>
      )}
    </div>
  );
}
